module.exports = __webpack_public_path__ + "static/img/img_logo.da523c68.png";